import React, { useEffect } from 'react';

import { SingleChoiceAnswerItem } from '../../../private/LearnEngineComponents/SingleChoiceAnswerItem/SingleChoiceAnswerItem';
import { AnswerOptionStatus, IAnswerOption } from '../../../../api/private/learn-engine-api/learn-engine-api.interface';
import { ISlAnswerProps } from '../../globalInterfaces/learnEngineInterfaces';

export function SlSingleChoiceAnswer({
	options,
	onChange,
	isValid,
}: ISlAnswerProps): JSX.Element {
	useEffect(() => {
		onChange(
			options.map((o) => ({
				...o,
				status: AnswerOptionStatus.Initial,
			})),
		);
	}, []);

	const onOptionSelect = (selectedOptionId: number) => {
		const changedOptions: IAnswerOption[] = options.map(
			(option: IAnswerOption) => ({
				...option,
				status: option.id === selectedOptionId
					? AnswerOptionStatus.Selected
					: AnswerOptionStatus.Initial,
			}),
		);
		isValid(true);
		onChange(changedOptions);
	};

	return (
		<>
			{options.map((option) => (
				<SingleChoiceAnswerItem
					key={option.id}
					option={option}
					onSelectOption={() => onOptionSelect(option.id)}
				/>
			))}
		</>
	);
}
